var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g4, _path26, _g5, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCelebration = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.069,
    d: "M51.86 58.958c-8.518-.022-31.765-24.345-29.803-32.517.006.463-17.292 41.277-16.905 41.79.24.928 1.206 2.155 1.94 2.93.805.82 1.704 1.683 2.778 2.09.51.447 42.249-14.51 42.728-14.472-.222.076-.46.168-.737.179"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.069,
    d: "m51.983 58.873-1.468.544c-6.513 2.182-16.313 1.1-25.33.064-8.486-.974-14.127-1.007-17.514 1.97.952-2.372 2.109-5.205 3.348-8.218 3.336-1.926 8.805-1.316 18.078.698 5.724 1.245 10.824 2.352 16.4 2.472.983.615 5.604 2.068 6.486 2.47M37.145 49.796c-7.258-2.08-17.318-5.638-23.098-3.89 1.292-3.119 1.926-4.655 3.072-7.412 1.81-.222 7.21 1.07 11.673 2.473 2.786 3.89 4.602 5.327 8.353 8.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M52.055 58.938C47.112 60.533 10.348 73.672 9.87 73.252a5 5 0 0 1-1.004-.53c7.1-5.913 28.954-9.196 28.954-16.614 0-5.802-9.237-11.591-10.708-17.481 6.952 9.597 19.094 20.317 24.749 20.331q.1-.004.194-.02",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0863BF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.069,
    d: "M54.3 52.329c-1.392-5.655-9.091-15.543-17.197-22.087s-13.55-7.265-12.158-1.611c1.39 5.654 9.09 15.543 17.197 22.087s13.55 7.265 12.158 1.61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M50.978 55.935c-1.375-3.59-1.319-8.647-1.92-13.214 2.68 3.602 4.61 7.04 5.242 9.606.776 3.151-.572 4.322-3.322 3.608M38.826 31.689c-3.255.002-6.67 1.04-10.002 1.04-.632 0-1.435-.054-2.299-.187-.755-1.436-1.299-2.76-1.581-3.911-1.392-5.654 4.052-4.933 12.158 1.61q.867.7 1.724 1.448M43.77 50.826q0 .663.09 1.22a51 51 0 0 1-1.719-1.332c-5.269-4.254-10.367-9.92-13.671-14.92 1.875-.437 3.865-.76 5.883-.76 5.368 0 10.156 2.56 10.156 8.23 0 2.55-.74 5.254-.74 7.562",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.069,
    d: "M53.904 58.055c3.767-3.757-2.82-12.8-5.262-16.013-4.275-5.697-15.99-17.893-23.31-17.815-1.896.046-3.589 1.553-3.477 3.52.35 5.253 6.26 12.688 9.702 16.642 4.082 4.716 17.698 18.016 22.347 13.666m-11.763-7.34c-8.106-6.543-15.805-16.432-17.197-22.086-1.391-5.655 4.052-4.933 12.158 1.61S52.908 46.673 54.3 52.327c1.392 5.655-4.052 4.933-12.158-1.61"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.076,
    d: "M32.359 65.78a2121 2121 0 0 1-11.294 3.909c-3.468 0-9.605-1.527-14.373 1.027-.648-.751-1.342-1.72-1.54-2.487-.053-.07.226-.897.746-2.272 6.652-4.009 18.726.615 26.46-.179z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2F302",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.069,
    d: "M10.258 73.21c-1.463.212-5.326-3.882-5.031-5.335-.559 1.333-1.065 2.83.396 4.427 1.58 1.725 3.256 1.346 4.504.948l-.007.001c.038-.01.08-.024.138-.041z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.12 73.25h.006c-1.216.388-2.839.757-4.382-.82.607.276 1.16.37 1.53.37.407 0 .77-.259.791-.698.838.708 1.669 1.184 2.193 1.108zM53.904 58.056c-3.073 2.875-10.064-1.961-15.63-6.933 2.955 2.351 9.117 6.173 12.56 6.173 1.073 0 1.924-.418 2.354-1.265 1.191-.351 1.635-1.576 1.111-3.704-.067-.274-.48-1.786-.781-2.325.05-.077.01-.094.063-.162 1.808 3.615 1.923 6.62.323 8.215",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "celebration_svg__a",
    width: 33,
    height: 33,
    x: 24,
    y: 24,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.307 51.808c-.23-.936 1.788-3.094 1.239-4.228-2.77-5.714-12.679-11.881-19.443-17.342-8.106-6.544-13.55-7.265-12.158-1.61 1.39 5.654 9.09 15.542 17.197 22.086 7.8 6.297 13.135 7.203 12.286 2.224-.033-.195.93-.917.879-1.13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#celebration_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M52.129 52.264c1.22-1.887.886-4.275-.748-5.332s-3.95-.385-5.17 1.502c-1.221 1.887-.887 4.274.747 5.331 1.635 1.058 3.95.386 5.17-1.501"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M52.22 52.243c-.46.734-1.123 1.357-1.912 1.72-1.11.514-2.39.48-3.41-.232 1.12.729 2.553.617 3.672-.051 1.537-.892 2.456-2.788 2.19-4.46-.134-.932-.635-1.805-1.437-2.32 1.705 1.016 2.142 3.362.896 5.344"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.021,
    d: "M52.22 52.243c-.46.734-1.123 1.357-1.912 1.72-1.11.514-2.39.48-3.41-.232 1.12.729 2.553.617 3.672-.051 1.537-.892 2.456-2.788 2.19-4.46-.134-.932-.635-1.805-1.437-2.32 1.705 1.016 2.142 3.362.896 5.344z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.052,
    d: "M52.22 52.243c-.46.734-1.123 1.357-1.912 1.72-1.11.514-2.39.48-3.41-.232 1.12.729 2.553.617 3.672-.051 1.537-.892 2.456-2.788 2.19-4.46-.134-.932-.635-1.805-1.437-2.32 1.705 1.016 2.142 3.362.896 5.344Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.021,
    d: "M51.727 46.163c-.921-.609-2.161-.784-3.199-.49a5.1 5.1 0 0 0-2.135 1.147c-1.458 1.299-2.215 3.44-1.64 5.358.318 1.098 1.09 2.024 2.128 2.49 1.362.624 2.928.387 4.218-.464l-.005.003c2.421-1.585 3.493-5.367 1.186-7.606a3.6 3.6 0 0 0-.554-.437zm-3.625 8.08c-.79-.181-1.487-.675-2.002-1.347-2.09-3.232 1.858-7.954 5.282-5.957 3.42 2.267.612 8.031-3.28 7.304m2.682-8.522-.063-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M29.722 37.997c2.057-.748 4.781.026 6.06 1.78.533.733.723 1.516.61 2.233-.172 1.105-1.06 1.915-2.09 2.276-.899.324-1.885.357-2.818.172-1.25-.245-2.5-.928-3.243-1.952-1.296-1.757-.537-3.803 1.48-4.508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042,
    d: "M29.769 37.81c1.178-.422 2.497-.353 3.667.064a5.4 5.4 0 0 1 1.717.986c1.036.89 1.574 2.151 1.194 3.367.323-1.235-.393-2.56-1.475-3.367a5.6 5.6 0 0 0-1.784-.896 5.8 5.8 0 0 0-2.04-.237c-1.535.087-3.035.935-3.372 2.333.2-1.002.896-1.812 2.093-2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042,
    d: "M28.128 37.96c-.2.14-.396.32-.569.505l.001-.002c-.134.135-.25.298-.356.457l.03-.047c-.637.921-.732 2.095-.325 3.135.087.222.193.457.323.66.137.22.29.44.459.636.754.903 1.914 1.572 3.01 1.887 1.62.482 3.517.385 4.943-.536.268-.17.525-.378.746-.617.086-.083.182-.203.254-.301.253-.342.44-.708.553-1.114.257-.9.139-1.832-.412-2.745-1.13-2.084-4.158-3.391-6.99-2.678h.004c-.371.09-.78.249-1.102.414l.05-.027a4.5 4.5 0 0 0-.634.386l.017-.013zm1.64-.152c2.083-.753 4.796.044 6.061 1.78 1.265 1.737.602 3.755-1.481 4.509-2.082.753-4.796-.044-6.06-1.78-1.264-1.737-.601-3.756 1.48-4.51"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    d: "M28.99 31.613c-1.055-.319-1.008-2.79-.103-5.52.907-2.73 2.604-4.44 3.46-4.185 1.199.36 1.077 2.634.171 5.251-1.042 3.01-2.46 4.775-3.529 4.453z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5E7A7",
    d: "M28.99 31.613c-1.055-.319-1.008-2.79-.103-5.52.907-2.73 2.604-4.44 3.46-4.185 1.199.36 1.077 2.634.171 5.251-1.042 3.01-2.46 4.775-3.529 4.453z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.052,
    d: "M28.99 31.613c-1.055-.319-1.008-2.79-.103-5.52.907-2.73 2.604-4.44 3.46-4.185 1.199.36 1.077 2.634.171 5.251-1.042 3.01-2.46 4.775-3.529 4.453z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.052,
    d: "M28.994 31.595c-.257-.077-.449-.287-.577-.602-.13-.317-.194-.739-.197-1.237-.007-.997.23-2.296.683-3.658s1.103-2.472 1.746-3.207c.321-.368.641-.642.932-.807s.554-.223.761-.161c.587.176.856.823.863 1.763.006.937-.25 2.159-.703 3.467-.52 1.504-1.136 2.696-1.752 3.472-.308.387-.617.669-.914.836-.296.165-.58.214-.842.136h0z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.613 30.977c-.733-.192-.511-2.217.25-4.512.763-2.295 2.05-3.882 2.631-3.69.685.228.633 2.108-.128 4.403-.68 2.047-2.05 3.985-2.753 3.8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.052,
    d: "M29.53 30.914c-.673-.173-.423-2.171.332-4.445s1.978-3.865 2.511-3.688c.628.208.536 2.059-.218 4.333-.674 2.029-1.982 3.964-2.626 3.8z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.113,
    d: "M35.552 34c.038-.487-.077-1.005-.272-1.51a8 8 0 0 0-.81-1.52 13 13 0 0 0-1.216-1.556l1.146-1.436a8.54 8.54 0 0 1 2.447 3.444c.194.508.303.942.362 1.25a5 5 0 0 1 .068.453v.002l-.546.374zM38.501 29.413c-.365-1.01-1.015-1.84-1.577-2.423a9 9 0 0 0-.975-.869l-.04-.03 1.526-1.907c1.144.733 1.912 1.699 2.394 2.486a8 8 0 0 1 .525 1.002q.082.19.12.296l.026.07z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "celebration_svg__b",
    width: 6,
    height: 3,
    x: 32,
    y: 32,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.113,
    d: "m33.325 33.862.047-.02-.016-.047-.403-1.166a8 8 0 0 0 3.107.713 6.3 6.3 0 0 0 1.155-.084l-1.318 1.475c-.888.307-1.84.195-2.574.003a7 7 0 0 1-1.145-.412z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#celebration_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#000",
    strokeWidth: 0.113,
    d: "m33.325 33.862.047-.02-.016-.047-.403-1.166a8 8 0 0 0 3.107.713 6.3 6.3 0 0 0 1.155-.084l-1.318 1.475c-.888.307-1.84.195-2.574.003a7 7 0 0 1-1.145-.412z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "celebration_svg__c",
    width: 8,
    height: 4,
    x: 33,
    y: 27,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.113,
    d: "M34.613 27.715h.001l.11.041q.146.054.41.14c.351.11.847.248 1.428.357 1.108.208 2.529.313 3.837-.083l-1.733 1.962-.012.003q-.028.007-.084.016a6 6 0 0 1-.323.049 8 8 0 0 1-1.185.056 9.8 9.8 0 0 1-3.794-.863z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#celebration_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#000",
    strokeWidth: 0.113,
    d: "M34.613 27.715h.001l.11.041q.146.054.41.14c.351.11.847.248 1.428.357 1.108.208 2.529.313 3.837-.083l-1.733 1.962-.012.003q-.028.007-.084.016a6 6 0 0 1-.323.049 8 8 0 0 1-1.185.056 9.8 9.8 0 0 1-3.794-.863z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#E7F3FF",
    stroke: "#000",
    strokeWidth: 0.113,
    d: "m37.477 24.134.029.014.193.088a13.212 13.212 0 0 0 3.143.925c1.841.294 4.12.203 5.975-1.284a8.077 8.077 0 0 1-2.468 2.241c-1.807 1.05-4.576 1.674-8.432-.035z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M60.278 38.708c-.63 1.206-1.959-.332-2.516-1.163-.744-1.096-1.318-2.333-1.748-3.678-.233-.751-.412-1.524-.47-2.286-.128-1.216.294-2.488 1.509-1.553 1.833 1.46 3.974 6.314 3.226 8.68"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.054,
    d: "M59.622 39.194c-.918.27-1.94-1.282-2.374-1.95a14.7 14.7 0 0 1-1.402-2.972c-.505-1.439-1.065-4.3.28-4.489-1.014.31-.351 3.575.18 4.799.389 1.04.879 2.05 1.507 2.968.425.579 1.28 1.767 2.098 1.526z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.054,
    d: "M61.167 36.128c-.528-2.43-1.901-5.596-3.752-7.022l.024.018a2.5 2.5 0 0 0-.543-.315h.001c-1.147-.459-1.778.39-1.849 1.468l.002-.008c-.006.06-.01.092-.016.206v-.003c-.03.556.034 1.08.076 1.352l-.004-.026c.313 2.204 1.384 4.801 2.67 6.548.593.76 1.468 1.856 2.508 1.681.441-.104.754-.481.893-.876.337-.958.175-2.055-.011-3.023zm-2.558 2.756c-1.511-1.164-4.062-6.19-3.079-8.705.792-1.101 2.235.945 2.695 1.692a14.4 14.4 0 0 1 1.694 4.09c.324 1.107.62 4.335-1.31 2.923"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#010E1B",
    strokeMiterlimit: 10,
    strokeWidth: 0.099,
    d: "m36.887 5 4.46-2 1.986 3.795-5.402 2.324z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#010E1B",
    strokeMiterlimit: 10,
    strokeWidth: 0.099,
    d: "m43.334 6.793.514 2.277-4.144 1.743-1.773-1.696z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M60.612 50.886c.35-.36.598-.848.773-1.378a8.3 8.3 0 0 0 .347-1.727 13 13 0 0 0 .048-2.025v-.002l1.853-.395a8.76 8.76 0 0 1-.3 4.328 8 8 0 0 1-.526 1.225 5 5 0 0 1-.24.404l-.005.005-.68-.06zM65.93 49.179c.37-1.038.396-2.121.33-2.949a9 9 0 0 0-.207-1.32l-.014-.057 2.462-.521c.431 1.328.411 2.594.28 3.533-.065.474-.158.864-.235 1.135a6 6 0 0 1-.098.314l-.027.077z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "celebration_svg__d",
    width: 6,
    height: 5,
    x: 57,
    y: 47,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "m58.953 49.32.043.013.015-.042.446-1.201a8.2 8.2 0 0 0 2 2.597 6.4 6.4 0 0 0 .987.695l-2.025.314c-.905-.335-1.587-1.044-2.044-1.675a7 7 0 0 1-.645-1.084q0-.002-.002-.003z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#celebration_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m58.953 49.32.043.013.015-.042.446-1.201a8.2 8.2 0 0 0 2 2.597 6.4 6.4 0 0 0 .987.695l-2.025.314c-.905-.335-1.587-1.044-2.044-1.675a7 7 0 0 1-.645-1.084q0-.002-.002-.003z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "celebration_svg__e",
    width: 8,
    height: 5,
    x: 61,
    y: 45,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1,
    d: "m63.97 45.297.003.006.06.104a12.7 12.7 0 0 0 1.131 1.587c.746.89 1.81 1.902 3.113 2.436l-2.676.43-.013-.006-.077-.042a6 6 0 0 1-.288-.171 8.6 8.6 0 0 1-.975-.727 10 10 0 0 1-2.448-3.16z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#celebration_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m63.97 45.297.003.006.06.104a12.7 12.7 0 0 0 1.131 1.587c.746.89 1.81 1.902 3.113 2.436l-2.676.43-.013-.006-.077-.042a6 6 0 0 1-.288-.171 8.6 8.6 0 0 1-.975-.727 10 10 0 0 1-2.448-3.16z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m68.566 44.32.017.035q.031.068.095.195a13.535 13.535 0 0 0 1.885 2.774c1.275 1.44 3.154 2.857 5.611 2.866a8.277 8.277 0 0 1-3.464.184c-2.116-.345-4.718-1.654-6.66-5.522z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m44.038 41.706-1.66 1.065.032.628 1.66-1.066-.031-.628h-.002z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m42.412 43.403.559.283 1.659-1.065-.559-.283-1.659 1.066v-.002Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#celebration_svg__f)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m43.31 40.094.12 2.514 2.236 1.133-.121-2.515z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#celebration_svg__g)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m48.34 39.432-2.798 1.794.121 2.515 2.797-1.795-.122-2.514z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#celebration_svg__h)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m46.103 38.294-2.797 1.795 2.235 1.133 2.797-1.797-2.235-1.132z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.099,
    d: "m46.102 38.285-2.796 1.795.12 2.514 2.797-1.794z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.099,
    d: "m43.428 42.601 2.235 1.133 2.796-1.794-2.235-1.133-2.797 1.794Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m46.228 40.807 2.234 1.133-.12-2.515-2.236-1.132.122 2.515z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m49.657 37.918-2.749 1.764.031.63 2.749-1.764-.031-.628z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.099,
    d: "m46.939 40.313.56.283 2.748-1.765-.559-.282-2.749 1.764Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m49.688 38.546.559.283-.031-.628-.559-.283z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m48.497 30.484-1.086 2.254.363.53 1.085-2.253z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m47.773 33.267.636-.053 1.086-2.253-.637.053z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#celebration_svg__i)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m47.003 29.768 1.449 2.12 2.546-.21-1.448-2.12-2.547.209z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#celebration_svg__j)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m52.501 23.435-2.952 6.124 1.449 2.12 2.952-6.123-1.449-2.122Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#celebration_svg__k)",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m49.955 23.643-2.952 6.124 2.547-.21 2.952-6.123z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.099,
    d: "m49.951 23.635-2.95 6.124 1.449 2.12 2.952-6.123-1.449-2.12h-.002z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeWidth: 0.099,
    d: "m48.448 31.882 2.547-.21 2.952-6.123-2.547.21z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m51.401 25.76 2.547-.21-1.45-2.12-2.546.21z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeWidth: 0.099,
    d: "m52.582 21.95-1.192 2.476.362.53 1.194-2.475-.363-.53v-.002z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m51.75 24.959.637-.053 1.193-2.476-.637.052z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m52.944 22.48.636-.052-.361-.53-.637.053.362.53h-.001Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#9DCEFF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m73.192 22.587-3.549.809-3.352-1.322 3.66-1.611z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A84FF",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m66.291 22.075.966-3.6 2.963-2.178-.269 4.166z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.099,
    d: "m69.951 20.463.268-4.166 2.517 2.607.456 3.684z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#EDFF00",
    d: "M48.543 14.862c.407 1.83-.666 4.074-2.397 5.016-1.73.94-3.462.22-3.868-1.609-.407-1.829.667-4.075 2.396-5.016 1.73-.94 3.462-.22 3.869 1.609"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FF99",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042,
    d: "m44.214 12.45-.03.017a.1.1 0 0 1 .024-.009c-1.28.686-2.196 1.889-2.669 3.244-.018.055-.059.173-.104.337-.283 1.047-.285 2.066.103 3.042.197.478.468.862.847 1.199.702.66 1.772.84 2.704.62a5 5 0 0 0 .356-.099c.2-.066.416-.158.604-.254v.001c.665-.33 1.289-.871 1.74-1.439.11-.138.186-.24.276-.37.726-1.062 1.163-2.377 1.046-3.707-.14-1.733-1.329-3.087-3.099-3.069-.626.004-1.247.192-1.797.487zm.463.84c1.73-.942 3.463-.221 3.87 1.608.405 1.83-.668 4.075-2.398 5.017-1.73.94-3.462.22-3.869-1.609-.406-1.83.667-4.076 2.397-5.017"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.042,
    d: "M47.346 13.172c1.051.586 1.402 1.904 1.255 3.034-.11.9-.48 1.76-1.031 2.477-1.004 1.331-2.829 2.174-4.239 1.267 1.402.793 3.203-.118 4.145-1.425.548-.74.91-1.628.991-2.55.103-1.088-.265-2.329-1.27-2.887z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "celebration_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.97161 -1.50419 1.5097 -.97518 45.588 39.157)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FAF1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFD98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3922E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "celebration_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-122.86 34.429 6.112)scale(1.78881 1.79633)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFD98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAF1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "celebration_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-154.43 29.845 9.496)scale(2.95601 2.96727)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FAF1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFD98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3922E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "celebration_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-154.43 27.79 7.608)scale(1.47753 1.48317)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFD98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAF1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__f",
    x1: 46.59,
    x2: 42.962,
    y1: 40.536,
    y2: 42.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFD98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAF1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "celebration_svg__i",
    x1: 50.091,
    x2: 48.211,
    y1: 28.4,
    y2: 32.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EBBB10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EFD98E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FAF1BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })))));
};
export default SvgCelebration;